import script from "./recording.vue?vue&type=script&lang=ts&setup=true"
export * from "./recording.vue?vue&type=script&lang=ts&setup=true"

import "./recording.vue?vue&type=style&index=0&id=3d788a59&scoped=true&lang=scss"

import exportComponent from "/Users/123imac-49/Desktop/123-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d788a59"]])

export default __exports__